import ToastContent, { ToastType } from "./ToastContent";
import React, { useCallback, useEffect, useState } from "react";
import CustomEvent from "custom-event";
import styled from "styled-components";
import { generateUUID } from "../../../utils/uid";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import {
  TOOLBAR_HEIGHT,
  TOOLBAR_PADDING,
} from "components/ReaderToolBar/consts";

const ADD_TOAST = "Toast.ADD_TOAST";
const TRANSITION_DURATION_MS = 500;

const Styled = {
  Container: styled.div`
    position: absolute;
    top: ${TOOLBAR_HEIGHT}px;
    left: 0;
    right: ${TOOLBAR_PADDING}px;
    pointer-events: none;
  `,
  ToastWrapper: styled.div`
    position: relative;
    transition: opacity ${TRANSITION_DURATION_MS}ms;
    float: right;
    clear: both;

    &.enter {
      opacity: 0;
    }
    &.enter-active {
      opacity: 1;
    }
    &.exit {
      opacity: 1;
    }
    &.exit-active {
      opacity: 0;
    }

    & > * {
      pointer-events: auto;
    }
  `,
};

export function showToast(type: ToastType, message: string) {
  document.dispatchEvent(
    new CustomEvent(ADD_TOAST, { detail: { type, message } })
  );
}

interface ToastInfo {
  type: ToastType;
  message: string;
  uid: string;
}

export const Toast = () => {
  const [toasts, setToasts] = useState<Array<ToastInfo>>([]);

  const onAddToast = useCallback(
    evt => {
      setToasts([
        ...toasts,
        {
          type: evt.detail.type,
          message: evt.detail.message,
          uid: generateUUID(),
        },
      ]);
    },
    [setToasts, toasts]
  );

  function onCloseToast(index: number) {
    const newToasts = [...toasts];
    newToasts.splice(index, 1);
    setToasts(newToasts);
  }

  useEffect(() => {
    document.addEventListener(ADD_TOAST, onAddToast);

    return () => {
      document.removeEventListener(ADD_TOAST, onAddToast);
    };
  }, [onAddToast]);

  return (
    <Styled.Container>
      <TransitionGroup>
        {toasts.map((t, i) => (
          <CSSTransition timeout={TRANSITION_DURATION_MS} key={t.uid}>
            <Styled.ToastWrapper>
              <ToastContent type={t.type} onClose={() => onCloseToast(i)}>
                {t.message}
              </ToastContent>
            </Styled.ToastWrapper>
          </CSSTransition>
        ))}
      </TransitionGroup>
    </Styled.Container>
  );
};
